import SvgIcon from 'common/components/svg-icon';


function CloseIcon(props) {
    return (
        <SvgIcon
            enableBackground='new 0 0 550.8 550.8'
            height='20'
            viewBox='0 0 550.8 550.8'
            width='20'
            x='0'
            xmlSpace='preserve'
            y='0'
            { ...props }>
            <polygon points='550.8,22.6 529.4,1.2 276,254.6 21.4,0 0,21.4 254.6,276 1.2,529.4 22.6,550.8 276,297.4 528.2,549.6 549.6,528.2 297.4,276' />
        </SvgIcon>
    );
}


export default CloseIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/close.js